import { MenuItem } from "@abaco/web-common/src/app";

export function createMenu(onClickCallback: () => void): MenuItem[] {
    return [
        {
            id: "malta-s4f-scp-bridge",
            descrKey: "malta-s4f-scp-bridge",
            icon: "abc-icon abc-icon-plant-circle",
            onClick: onClickCallback,
            get isVisible() {
                return true;
            }
        }
    ];
}